import { gql } from '@apollo/client';

export default gql`
  mutation createPlace(
    $name: String!
    $street: String!
    $city: String!
    $zipCode: String!
    $phone: String
    $email: String
    $contactPerson: String
    $notes: String
  ) {
    createPlace(
      input: {
        name: $name
        street: $street
        city: $city
        zipCode: $zipCode
        phone: $phone
        email: $email
        contactPerson: $contactPerson
        notes: $notes
      }
    ) {
      place {
        id
        name
      }
    }
  }
`;
